<template>
  <div>
    <Teleport v-if="afetrTitleActionSpaceMounted" to="#page-title-action-space">
      <div class="d-flex align-items-center justify-content-end w-100">
        <BasicButton
          label="編集"
          variant="secondary"
          outlined
          icon="pi pi-pencil"
          @click="
            goto({
              name: 'UsersSponsorsEdit',
            })
          "
        />
      </div>
    </Teleport>

    <Card>
      <template #content>
        <div class="py-3">
          <i v-if="!sponsors" class="pi pi-spin pi-spinner"></i>
          <div v-else-if="Object.keys(sponsors).length" class="h-100">
            <SponsorList :sponsors="sponsors" />
          </div>
          <span v-else class="text-danger">スポンサーが作成されていません</span>
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { useRouterUtil, useSponsors } from "/@/vue/composables";
import { BasicButton } from "/@/vue/components/Atom";
import { UserPageActions } from "/@/vue/components/Layouts";
import { List as SponsorList } from "/@/vue/components/Molecules/Sponsors";
import Card from "primevue/card";
import { inject } from "vue";

const afetrTitleActionSpaceMounted = inject("afetrTitleActionSpaceMounted");

const { goto } = useRouterUtil();

// api

const { getSponsors } = useSponsors();
const { data: sponsors, mutate: getNewsMutate } = getSponsors();
</script>

<style lang="scss" scoped></style>
